import { type BundleKey } from './types';

export const isBlank = (s: string | null | undefined) => !s || s.trim() === '';
export const num = (v: number | null | undefined) => v ?? 0;
export const isChance = (v: number) => v >= 0 && v <= 1;
/** Mirrors `ContentValidator.IsSlug`: lowercase letters and digits in groups joined by single hyphens, max 48. */
export const isSlug = (s: string) => s.length <= 48 && /^[a-z0-9]+(-[a-z0-9]+)*$/.test(s);

export type Err = (
  section: BundleKey,
  index: number | undefined,
  path: string,
  message: string,
) => void;
export type Ids = <T extends { id?: string | null }>(
  section: BundleKey,
  list: (T | null | undefined)[],
  kind: string,
  base?: string,
) => Set<string>;
